import script from "./RightSidebarAdminKunde.vue?vue&type=script&setup=true&lang=js"
export * from "./RightSidebarAdminKunde.vue?vue&type=script&setup=true&lang=js"

import "@/assets/styles/sfc/components/modules/RightSidebarAdminKunde.css?vue&type=style&index=0&id=5da7adda&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5da7adda"]])

export default __exports__